import { CommonModule, DecimalPipe } from '@angular/common';
import { Component, inject, effect, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbDatepickerModule, NgbModule, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '@services/core/user.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { BudgetGenerateService } from '@services/budget-generate.service';
import Swal from 'sweetalert2';
import { registerLocaleData } from '@angular/common';
import { Entity } from '@model/entity.model';
import localeEs from '@angular/common/locales/es';
import { LOCALE_ID, NgModule } from '@angular/core';
import { EmployeeModel } from './setting-budget.model';
import { forkJoin } from 'rxjs';
import { NumberFormatDirective } from '@directives/number-format.directive';

registerLocaleData(localeEs);


@Component({
  selector: 'app-setting-budget',
  standalone: true,
  imports: [ CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    NgbDatepickerModule,
    NgbModule,
    NumberFormatDirective
  ],
  providers: [NgbModal, { provide: LOCALE_ID, useValue: 'es-ES' }, DecimalPipe],
  templateUrl: './setting-budget.component.html',
  styleUrl: './setting-budget.component.css',
})
export class SettingBudgetComponent implements OnDestroy {
  @ViewChild('modal_budget', { static: true }) modalBudget: any;
  @ViewChild('modal_factor', { static: false }) modalFactor: any;
  @Input() isNewBudget!: boolean;
  @Input() year!: number;
  @Input() version!: number;
  @Input() isReadOnly: boolean = false;
  @Output() closeSettingBudget = new EventEmitter<boolean>();

  private modalRef: NgbModalRef;
  private userService = inject(UserService);
  private budgeGenrateService = inject(BudgetGenerateService);
  private decimalPipe = inject(DecimalPipe);
  public filter: EmployeeModel = new EmployeeModel();
  public entitySelected: Entity;
  public dataEmployeeType;
  public selectedEmployeeType;
  public budgetEmployeeType;
  public dataListDiverse;
  public dataNgSelectAssinet;
  public budget;  
  public budgetTemp;;
  public formBudget: FormGroup;
  public formFactor: FormGroup;
  public selectedFactor: any;
  public budgetFactors;
  public factorRea;
  closeResult: string;
  modalOptions = {
    animation: true,
  };
  public usePreviousBudget=false;
  public budgetVersionSelected;
  public budgetImportLog: { [key: string]: any[] } = {};
  public importTypeRef;
  public budgetStatusRef;
  isChange=false;
  public aasinetFundSelect;
  public selectedFund;
  public budgetFund;
  constructor(private modalService: NgbModal, private formBuilder: FormBuilder,) {
    effect(() => {
      this.entitySelected = this.userService.sharingEntity();
      if (this.entitySelected && Object.keys(this.entitySelected).length > 0) {
         this.formBudget.patchValue({
          entityCode: this.entitySelected.code,
        });
      }
    });
  }


  


  /**crear formulario reactivo diverso*/
  createFormBudget() {
    this.formBudget = this.formBuilder.group({
      id:[undefined],
      entityCode: ['', [Validators.required, Validators.minLength(1)]],
      year: ['', [Validators.required, Validators.minLength(1)]],
      version: ['', Validators.required],
      name: ['', [Validators.required]],
      vote: [''],
      status: [''],
    });
  }


  /**crear formulario reactivo para factor*/
  createFormFactor() {
    this.formFactor = this.formBuilder.group({
      value: ['', [Validators.required]]
    });
  }

  ngOnInit() {
    this.createFormBudget();
    this.createFormFactor();
    this.initFilterAndForm();
    this.loadAllData();
  }

  /*inicializa el filtro y deshabilita campos base*/
  private initFilterAndForm() {
    this.filter.year = this.year;
    this.filter.version = this.version; 
    this.formBudget.patchValue({ year: this.year, version: this.version });
    ['entityCode', 'year', 'version'].forEach(k => this.formBudget.get(k)?.disable());
    if (this.isReadOnly) this.formBudget.disable();
  }

  /*carga los datos asociados al presupuesto*/
  private loadAllData() {
    this.getBudget();
    this.getBudgetFactors();
    this.getFactorRea();
    this.getEmployeeType();
    this.getBudgetImportLog();        
    this.getBudgetStatusRef();
    this.getAasinetFund();
  }


  syncWithAasinet() {
    this.loading('Sincronizando con Aasinet');  
    forkJoin({
      subAccounts: this.budgeGenrateService.syncAssinetSubAccount(),
      departaments: this.budgeGenrateService.syncAssinetDepartament(),
      accounts: this.budgeGenrateService.syncAssinetAccount()
    }).subscribe({
      next: (result) => {
        Swal.fire({
          icon: 'success',
          title: '¡Sincronización completada!',
          html: `
            <ul style="text-align: left; padding-left: 1.2em;list-style: none;">
              <li style="display: flex; justify-content: space-between;">Subcuentas completadas<i class="fas fa-check text-success"></i></li>
              <li style="display: flex; justify-content: space-between;">Departamentos completados<i class="fas fa-check text-success"></i></li>
              <li style="display: flex; justify-content: space-between;">Cuentas completadas<i class="fas fa-check text-success"></i></li>
            </ul>
          `,
          showConfirmButton: false,
          timer: 2500
        });
      },
      error: (err) => {
        console.error('Error en sincronización:', err);
        Swal.fire({
          icon: 'error',
          title: 'Error en la sincronización',
          text: 'Revisa la consola para más detalles.'
        });
      }
    });
  }
  

  syncAssinetSubAccount() {
    return this.budgeGenrateService.syncAssinetSubAccount();
  }
  
  syncAssinetDepartament() {
    return this.budgeGenrateService.syncAssinetDepartament();
  }
  
  asyncAssinetAccount() {
    return this.budgeGenrateService.syncAssinetAccount();
  } 

  getEmployeeType() {
    this.budgeGenrateService.getEmployeeType().subscribe(res => {
      this.dataEmployeeType =this.ngSelectData(res);
      this.getBudgetEmployeeType();
    }, (error => console.error(error)));
  }

  getBudgetFund() {
    let filter={...this.filter};
    delete filter.entityCode;
    this.budgeGenrateService.getBudgetFund(filter).subscribe(res => {
      this.selectedFund=this.mapSelectFund(res);
      this.budgetFund =res;
    }, (error => console.error(error)));
  }

  mapSelectFund(fund) {
    let newData = fund.map(d => d.fundCode);
    return newData
  }


  /**trae los tipos de empleados del presupuesto */
  getBudgetEmployeeType() {
    let filter={...this.filter};
    delete filter.entityCode;
    this.budgeGenrateService.getBudgetEmployeeType(filter).subscribe(res => {
      this.budgetEmployeeType=res;
      this.selectedEmployeeType=this.mapSelectEmployeeType(res);
    }, (error => console.error(error)));
  }



  getAasinetFund() {
    this.budgeGenrateService.getAasinetFund().subscribe(res => {
      this.getBudgetFund();
      res=res.filter(d=>d.acceptEntries);
      this.aasinetFundSelect=this.ngSelectDataAasinetFund(res);
    }, (error => console.error(error)));
  }

  syncAssinetBudget() {
    let filter={...this.filter}
    delete filter.entityCode;
    this.budgeGenrateService.syncAssinetBudget( this.filter.year).subscribe(res => {
      this.budgeGenrateService.importPreviousBudget(filter).subscribe(res => {
        this.getBudgetFund();
        
    })
      
    }, (error => console.error(error)));
  }

    /*mapea los datos del ng-select */
    ngSelectDataAasinetFund(aasinetFund) {
      let newData = aasinetFund.map((d) => {
        return {
          code: d.code,
          nameCode: d.code + ' - ' + d.name,
          name: d.name
        }
      });
      return newData
    }

    findBudgetFund(fundCode) {
      return this.budgetFund.find(d=>d.fundCode==fundCode)
    }

    addBudgetFund(e) {
      if (this.isReadOnly) return;
      const payload = {
        entityCode: this.filter.entityCode,
        year: this.filter.year,
        version: this.filter.version,
        fundCode: e.code
      };
      this.budgeGenrateService.saveBudgetFund(payload).subscribe(() => {
        this.isChange = true;
      }, (error => console.error(error)));
    }

    removeBudgetFund(e) {
      if (this.isReadOnly) return;
      const budgetFund = this.findBudgetFund(e.code);
      this.budgeGenrateService.deleteBudgetFund({ id: budgetFund.id }).subscribe(() => {
        this.isChange = true;
      }, (error => console.error(error)));
    }
    


  getBudgetImportLog() {
    let filter={...this.filter};
    delete filter.entityCode;
    this.budgeGenrateService.getBudgetImportLog(filter).subscribe(res => {
      this.budgetImportLog=res;
    }, (error => console.error(error)));
  }


  mapSelectEmployeeType(employeeType) {
    let newData = employeeType.map(d => d.employeeType);
    return newData
  }

  changeBudget(e, field) {
    if (this.isReadOnly) return;
    this.formBudget.patchValue({
      [field]: e.target.value
    });
  }


  getBudgetStatusRef() {
    this.budgeGenrateService.getBudgetStatusRef().subscribe(res => {
      this.budgetStatusRef = res;
    }, (error => console.error(error)));
  }


  /** */

  findBudgetEmployeeType(employeeType) {
    return this.budgetEmployeeType.find(d=>d.employeeType==employeeType)
  }


  updateBudget() {
    if (this.isReadOnly) return;
    this.budgeGenrateService.updateBudget(this.formBudget.value).subscribe(() => {
      this.isChange = true;
      this.closeSettingBudget.emit(false);
    }, (error => console.error(error)));
  }

  removeBudgetEmployeeType(e) {
    if (this.isReadOnly) return;
    const budgetEmployeeType = this.findBudgetEmployeeType(e.id);
    this.budgeGenrateService.deleteBudgetEmployeeType({ id: budgetEmployeeType.id }).subscribe(() => {
      this.isChange = true;
    });
  }

  addBudgetEmployeeType(e) {
    if (this.isReadOnly) return;
    const payload = {
      entityCode: this.filter.entityCode,
      year: this.filter.year,
      version: this.filter.version,
      employeeType: e.id
    };
    this.budgeGenrateService.saveBudgetEmployeeType(payload).subscribe(() => {
      this.isChange = true;
    }, (error => console.error(error)));
  }

/**guarda los tipos de empleados del presupuesto al salir del ng-select */
  clickCloseSettingBudget() {    
    if(this.isChange){     
      this.userService.refreshBudgetVersion();
    }
    this.closeSettingBudget.emit(false);
  }




  getBudgetFactors() {
    let filter={...this.filter};
    delete filter.entityCode;
    this.budgeGenrateService.getBudgetFactors(filter).subscribe((res) => {
      this.budgetFactors = res;
    }, (error => console.error(error)));
  }

  getFactorRea() {
    let filter={...this.filter};
    delete filter.entityCode;
    this.budgeGenrateService.getFactorRea(filter).subscribe((res) => {
      this.factorRea = res;
    }, (error => console.error(error)));
  }


 
  /*abre los modales */
  open(content, options?) {
    this.modalRef = this.modalService.open(content, options || this.modalOptions);
  }

  /*cierra los modales */
  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }

  openModalEditFactor(factor: any) {
    if (this.isReadOnly) return;
    this.selectedFactor = factor;
    const formattedValue = this.decimalPipe.transform(
      factor.value,
      `1.${factor.decimalPlaces ?? 0}-${factor.decimalPlaces ?? 0}`
    );
    this.formFactor.patchValue({
      value: formattedValue
    });
    this.formFactor.markAsPristine();
    this.open(this.modalFactor);
  }

  submitFactorUpdate() {
    if (this.formFactor.valid && this.selectedFactor) {
      let rawValue = this.formFactor.value.value ?? 0;
      let value = typeof rawValue === 'string'
        ? parseFloat(rawValue.replace(/\./g, '').replace(',', '.'))
        : Number(rawValue);

      this.budgeGenrateService.updateBudgetFactors({
        id: this.selectedFactor.id,
        value: value
      }).subscribe({
        next: () => {
          this.isChange = true;
          this.close();
          this.getBudgetFactors();
          Swal.fire({
            icon: 'success',
            title: 'Factor actualizado',
            text: `El factor ${this.selectedFactor.name} ha sido actualizado correctamente.`,
            timer: 2000,
            showConfirmButton: false
          });
        },
        error: (err) => {
          console.error(err);
          Swal.fire('Error', 'No se pudo actualizar el factor.', 'error');
        }
      });
    }
  }

  /*mensaje de cargando */
  loading(title) {
    Swal.fire({
      title: title,
      html: 'Por favor, espere',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });
  }


  /*trae los datos del presupuesto*/
  getBudget() {
    this.loading('Cargando Configuraciones');
    const filter = { year: this.filter.year, version: this.filter.version };
    this.budgeGenrateService.getBudget(filter).subscribe({
      next: (res) => this.handleBudgetSuccess(res),
      error: (err) => console.error(err)
    });
  }

  /*procesa la respuesta del presupuesto*/
  private handleBudgetSuccess(res) {
    this.budget = res;
    this.applyBudgetToForm(res?.[0]);
    this.budgetTemp = JSON.parse(JSON.stringify(this.budget));
    this.dataListDiverse = this.ngSelectData(res);
    Swal.close();
  }

  /*aplica valores y modo lectura al formulario*/
  private applyBudgetToForm(budget) {
    this.formBudget.patchValue({
      id: budget?.id, name: budget?.name,
      status: budget?.status, vote: budget?.vote ?? ''
    });
    this.isReadOnly = this.isReadOnly || (budget?.status ?? 0) !== 2;
    if (this.isReadOnly) this.formBudget.disable();
  }



/**busca los diverso  */



  /*mapea los datos del ng-select */
  ngSelectData(diverse) {
    let newData = diverse.map((d) => {
      return {
        id: d.id,
        nameId: d.id + ' - ' + d.name,
        name: d.name
      }
    });
    return newData
  }

  /**abre el modal del diverse */

  openModalBudget() {
    this.formBudget.reset();
    this.formBudget.patchValue({
      entityCode: this.entitySelected?.code,
      year: '',
      version: '1',
      name: '',
      vote: '',
      status: 2,
      selected: '0',
    });
    this.formBudget.markAsPristine();
    this.open(this.modalBudget);
  }


  ngOnDestroy() {
    this.userService.refreshBudgetVersion().subscribe(); 

  }



}



